export enum Claims {
    // tenants

    CreateChildTenant = "tenant.child.create",
    CreateAnyTenant = "tenant.global.create",
    ViewChildTenant = "tenant.child.view",
    ViewAnyTenant = "tenant.global.view",
    EditChildTenant = "tenant.child.edit",
    EditAnyTenant = "tenant.global.edit",
    DeleteChildTenant = "tenant.child.delete",
    DeleteAnyTenant = "tenant.global.delete",

    // users

    CreateUser = "user.tenant.create",
    ViewUser = "user.tenant.view",
    ViewUserGlobal = "user.global.view",
    EditUser = "user.tenant.edit",
    EditUserGlobal = "user.global.edit",
    DeleteUser = "user.tenant.delete",
    DeleteUserGlobal = "user.global.delete",

    ResetMfa = "user.tenant.resetMfa",

    // roles

    CreateCustomRole = "role.global.create",
    DeleteCustomRole = "role.global.delete",

    // assign roles to user

    AssignGlobalAdminRole = "role.global.assignGlobalAdmin",
    AssignSuperAdminRole = "role.tenant.assignSuperAdmin",
    AssignLeadRole = "role.tenant.assignLead",
    AssignCoordinatorRole = "role.tenant.assignCoordinator",
    AssignInvoicingRole = "role.tenant.assignInvoicing",
    AssignSurgerySchedulerRole = "role.tenant.assignSurgeryScheduler",
    AssignSurgeonRole = "role.tenant.assignSurgeon",
    AssignCustomRole = "role.tenant.assignCustom",
    AssignCustomRoleGlobal = "role.global.assignCustom",

    // app settings

    EditCurrentTenantAppSettings = "appSettings.tenant.edit",
    EditAnyTenantAppSettings = "appSettings.global.edit",

    // claims

    AssignGlobalClaims = "claim.global.assign",

    // assign claims to user

    AssignClaimToUser = "claim.tenant.assignUser",
    AssignClaimToCoordinator = "claim.tenant.assignCoord",
    AssignClaimToLead = "claim.tenant.assignLead",
    AssignClaimToSuperAdmin = "claim.tenant.assignSuperAdmin",

    // assign claims to role

    AssignClaimToUserRole = "claim.tenant.assignUserRole",
    AssignClaimToCoordinatorRole = "claim.tenant.assignCoordRole",
    AssignClaimToLeadRole = "claim.tenant.assignLeadRole",
    AssignClaimToSuperAdminRole = "claim.tenant.assignSuperAdminRole",
    AssignClaimToCustomRole = "claim.tenant.assignCustomRole",
    AssignClaimToGuestRole = "claim.global.assignGuestRole",

    // accounts

    UploadAccount = "account.tenant.upload",
    CreateAccount = "account.tenant.create",
    ViewAccount = "account.tenant.view",
    EditAccount = "account.tenant.edit",
    DeleteAccount = "account.tenant.delete",

    // call backs

    CreateCallBack = "callBack.tenant.create",
    EditCallBack = "callBack.tenant.edit",

    // cases

    CreateCase = "case.tenant.create",

    // content
    ViewInternal = "content.tenant.viewInternal",

    // countries

    ManageCountries = "country.tenant.manage",

    // donors
    LockSerologies = "donor.tenant.lockSerologies",
    SignPendingFollowUps = "donor.tenant.signPendingFollowUps",
    SignDonorEligibility = "donor.tenant.signDonorEligibility",
    EditDetermination = "donor.tenant.editDetermination",
    SignDetermination = "donor.tenant.signDetermination",
    UnlockDetermination = "donor.tenant.unlockDetermination",
    FlagDonor = "donor.tenant.flagDonor",
    UnlockDonor = "donor.tenant.unlockDonor",
    SendDonorLetters = "donor.tenant.sendLetters",

    // forms

    EditFormAfterTissueDistribution = "form.tenant.editAfterTissueDistribution",

    ArchiveForm = "form.tenant.archive",
    UnlockForm = "form.tenant.unlock",

    // form selects

    UploadFormSelect = "formSelect.tenant.upload",
    CreateFormSelect = "formSelect.tenant.create",
    ViewFormSelect = "formSelect.tenant.view",
    EditFormSelect = "formSelect.tenant.edit",
    EditFormSelectSlug = "formSelect.tenant.editSlug",
    DeleteFormSelect = "formSelect.tenant.delete",

    // form select options

    CreateFormSelectOption = "formSelect.tenant.createOption",
    EditFormSelectOption = "formSelect.tenant.editOption",
    DeleteFormSelectOption = "formSelect.tenant.deleteOption",

    // form select categories

    CreateFormSelectCategory = "formSelectCategory.tenant.create",
    ViewFormSelectCategory = "formSelectCategory.tenant.view",
    EditFormSelectCategory = "formSelectCategory.tenant.edit",
    DeleteFormSelectCategory = "formSelectCategory.tenant.delete",

    // notification configs

    ViewNotificationConfig = "notification.tenant.view",
    EditNotificationConfig = "notification.tenant.edit",

    // orders & shipping

    CreateOrder = "order.tenant.create",
    EditOrder = "order.tenant.edit",
    DeleteOrder = "order.tenant.delete",

    CreateShipment = "order.tenant.createShipment",
    EditShipment = "order.tenant.editShipment",
    DeleteShipment = "order.tenant.deleteShipment",
    PackShipment = "order.tenant.packShipment",

    ManageShippingMethod = "order.tenant.manageShippingMethod",

    // person

    CreatePerson = "person.tenant.create",
    ViewPerson = "person.tenant.view",
    EditPerson = "person.tenant.edit",
    DeletePerson = "person.tenant.delete",

    ViewPersonType = "person.tenant.viewType",
    ManagePersonType = "person.tenant.manageType",

    // referral

    ExportReferral = "referral.tenant.export",

    // surgery

    CreateSurgery = "surgery.tenant.create",
    EditSurgery = "surgery.tenant.edit",
    ViewSurgery = "surgery.tenant.view",
    DeleteSurgery = "surgery.tenant.delete",
    ApproveSurgery = "surgery.tenant.approve",
    ApproveSurgeryFeeWaiver = "surgery.tenant.SurgeryFeeWaiver",

    // surgery scheduler surgeon

    CreateSurgerySchedulerSurgeon = "surgerySchedulerSurgeon.tenant.create",
    EditSurgerySchedulerSurgeon = "surgerySchedulerSurgeon.tenant.edit",
    ViewSurgerySchedulerSurgeon = "surgerySchedulerSurgeon.tenant.view",
    DeleteSurgerySchedulerSurgeon = "surgerySchedulerSurgeon.tenant.delete",

    // tissues

    SignInitialGrading = "tissue.tenant.signInitialGrading",
    UnlockInitialGrading = "tissue.tenant.unlockInitialGrading",

    CreateProcedure = "tissue.tenant.createProcedure",
    EditProcedure = "tissue.tenant.editProcedure",
    DeleteProcedure = "tissue.tenant.deleteProcedure",
    FinalizeProcedure = "tissue.tenant.finalizeProcedure",

    SignProcedureGrading = "tissue.tenant.signProcedureGrading",
    UnlockProcedureGrading = "tissue.tenant.unlockProcedureGrading",
    EditPreservationMediumInfo = "tissue.tenant.editPreservationMediumInfo",
    ExportToPOB = "tissue.tenant.exportToPOB",

    OfferTissue = "tissue.tenant.offer",

    // invoices

    CreateInvoice = "invoice.tenant.create",
    EditInvoice = "invoice.tenant.edit",
    ViewInvoice = "invoice.tenant.view",
    DeleteInvoice = "invoice.tenant.delete",

    ManageStandardFees = "invoice.tenant.manageStandardFees",
    ManageAccountFees = "invoice.tenant.manageAccountFees",
    ManageAccountCredit = "invoice.tenant.manageAccountCredit",
}

export const ClaimsForAssigningRoles = [
    Claims.AssignGlobalAdminRole,
    Claims.AssignSuperAdminRole,
    Claims.AssignLeadRole,
    Claims.AssignCoordinatorRole,
    Claims.AssignInvoicingRole,
    Claims.AssignSurgerySchedulerRole,
    Claims.AssignSurgeonRole,
    Claims.EditPreservationMediumInfo,
];
